import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type State = {
  activeIndex: number
  leftEdge: boolean
  rightEdge: boolean
}

type Props = {
  children: (arg0: {
    activeIndex: number
    handleChangeActiveIndex: (arg0: number) => void
  }) => React.ReactNode
  className?: string
  variant?: 'white' | 'blue'
}

class Slider extends React.PureComponent<Props, State> {
  static defaultProps = {
    className: '',
    variant: 'white',
  }

  state = {
    activeIndex: -1,
    leftEdge: true,
    rightEdge: false,
  }

  handleScroll = (event: React.SyntheticEvent<HTMLDivElement>) => {
    this.handleDisplayingOverflowArrows(event.currentTarget)
  }

  handleDisplayingOverflowArrows = (element: HTMLDivElement) => {
    const scrollPosition = element.scrollLeft
    const rightBoundary = element.scrollWidth - element.offsetWidth

    this.setState({
      leftEdge: scrollPosition === 0,
      rightEdge: scrollPosition === rightBoundary,
    })
  }

  handleChangeActiveIndex = (activeIndex: number) => {
    this.setState({ activeIndex })
  }

  render() {
    const { className, variant } = this.props
    const { leftEdge, rightEdge } = this.state

    return (
      <div className={classNames(style.wrapper, className)}>
        <div
          className={classNames(style.scroll, variant && style[variant], {
            [style.showLeftArrow]: !leftEdge,
            [style.showRightArrow]: !rightEdge,
          })}
          onScroll={this.handleScroll}
        >
          {this.props.children({
            activeIndex: this.state.activeIndex,
            handleChangeActiveIndex: this.handleChangeActiveIndex,
          })}
        </div>
      </div>
    )
  }
}

export default Slider
